// vim: set ts=2 sw=2 et tw=72 ft=javascript:
/**
 * Copyright (C) 2015 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:EVENTS
 */

var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'templito:community/calendar': []
})(this, function (m_module, Backbone, $, _) {

  "use strict";

  var M = m_module.M;
  M.Community = M.Community || {};
  M.Community.View = M.Community.View || {};
  M.Community.View.Calendar = M.Community.View.Calendar || {};

  /**
   * @class M.Community.View.Calendar.SubscriptionPopup
   *
   * It finds this.options.subscribeButton and appends popup dialog after it
   * The dialog is hidden by default, and is shown when the button clicked
   *
   * IMPORTANT: For the popup to position correctly, the button needs a wrapper div
   * that is positioned right around the button and is relatively positioned.
   * The popup will use the parent div (the wrapper) to position itself.
   *
   */
  M.Community.View.Calendar.SubscriptionPopup = Backbone.View.extend({
    className: 'calendarSubscriptionPopup',
    template: M.Template.Community.Calendar.SubscriptionPopup,


    initialize: function() {
      M.required(this.options.subscribeButton);
      M.required(this.options.subscriptionLink);
      this.subscribeButton = this.options.subscribeButton;
      this.subscriptionLink = this.options.subscriptionLink;
      this.$el = $(this.el);
      this.$el.hide();
    },

    render: function() {
      this.$el.html(this.template);
      this._togglePopupVisibility();
      this._hidePopupOnPageClick();
      this._autoHighlightTextbox();

      this.subscribeButton.after(this.$el);

      return this;
    },

    _positionUnderSubscribeButton: function() {
      var buttonHeight = this.subscribeButton.offsetParent().height();
      var buttonWidth = this.subscribeButton.outerWidth();
      var dropdownWidth = this.$el.innerWidth();
      this.$el.css({
        top: buttonHeight,
        left: (buttonWidth - dropdownWidth) / 2
      });
    },

    _togglePopupVisibility: function() {
      var that = this;
      that.subscribeButton.click(function(event) {
        that._positionUnderSubscribeButton();
        that.$el.toggle();
        if (that.$el.css('display') != 'none') {
          that.$el.find('input.subscriptionLink').val(that.subscriptionLink);
          that.$el.find('input.subscriptionLink').select();
        }
      });
    },

    _hidePopupOnPageClick: function() {
      var that = this;
      $('body').click(function(event) {
        // if clicked on the button or the popup box, do not trigger hide action
        // _togglePopupVisibility() handles clicks on the button
        if (!$(event.target).closest(that.subscribeButton).length &&
            !$(event.target).closest(that.$el.find('.popupBox')).length) {
          that.$el.hide();
        }
      });
    },

    _autoHighlightTextbox: function() {
      this.$el.find('input.subscriptionLink').click(function() {
        $(this).select();
      });
    }

  });

  return {
  };

});
